import React, { Fragment, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { loginSuccess, setUser } from '../redux/actions/LoggedInAction';
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import toast from 'react-hot-toast';
import LocationResources from "../resources/LocationResources";
import UserResources from "../resources/UserResources";
import RotaResources from "../resources/RotaResources";
import Select from 'react-select';
import moment from "moment";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function validate(email) {
    return {
      email: email.length === 0,
    };
  }

function MemberPasswordResetRequest({loginSuccess, setUser}){   
    

      const [formData, setformData] = useState({
        email: '',
      });
    
    
    const userResources = new UserResources()
    const today = new Date();
       
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setformData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

      
    const canBeSubmitted = (dataToSubmit) => {
        const errors = validate(dataToSubmit['email']);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return !isDisabled;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
       
        if (!canBeSubmitted(formData)){
            toast.error("Fill out all the fields")
            return
        }
        userResources.user_pwd_reset_request_post(formData).then(res => {
            if (res.error.length < 1) {
                toast.success("Check your email for password reset link.");
                setTimeout(() => {
                    window.location.href = window.location.origin + '/registration';
                  }, 200);
            }
            else {
                toast.error("Reset failed, ensure you use the same email as when you registered.")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });

       
      };

    useEffect(() => {     
        
    }, []);
    

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            {/* <div className="page-banner parallax" style={{backgroundImage: "url(assets/images/testjpeg1280.jpg)"}}> */}
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Password Reset Request</strong></h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="spacer-10"></div>

            {/* <!-- Main Content --> */}
            <div id="main-container">
                <div className="content">
                        <div className="text-align-center">
                            <h2>Enter Your Registered Email</h2>
                        </div>
                <div className="container" id="openings" style={{alignItems:"center"}} >                        
                        <div className="col-md-12" style={{alignItems:"center"}}>                	
                            <div className="col-md-10 col-sm-10 mx-auto">
                                <div className="well widget widget_volunteer_form">
                                <form onSubmit={handleSubmit}>                                    
                                    <div className="row">                                        
                                        
                                        <div className="spacer-20"></div>
                                            <label>Email<span style={{color:"red"}}>*</span></label>
                                            <input type="email" className="form-control"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                            />                                                                          
                                    </div> 
                                    <div className="spacer-20"></div>                                    
                                        <div className="spacer-30"></div>                                        
                                        <input style={{backgroundColor:"#003165"}} type="submit" className="btn btn-primary" value="Submit"/>
                                        <div className="spacer-10"></div>
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="spacer-20"></div>
                    <div className="spacer-40"></div>
                              
                  
                    
                </div>
            </div>

            <Footer/>     
        </Fragment>
    )
}

const mapDispatchToProps = {
    loginSuccess,
    setUser,
};

export default connect(null, mapDispatchToProps)(MemberPasswordResetRequest);
